import { render, staticRenderFns } from "./DebtorsList.vue?vue&type=template&id=5d53bb2d&scoped=true&"
import script from "./DebtorsList.vue?vue&type=script&lang=js&"
export * from "./DebtorsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d53bb2d",
  null
  
)

export default component.exports